import moment from "moment-timezone";
import * as Yup from 'yup';
import { errorToaster } from "../../../reusable/common";
import { getCurrentEventId, getUTCDateNTime } from "../../../Utils/helpers";
import redirectIcon  from '../../../assets/img/redirect.svg'
export const eventId = getCurrentEventId();

export const stripHtmlTags = (html) => {
    const doc = new DOMParser().parseFromString(html, "text/html");
    return doc.body.textContent || "";
  };
export const SCREENS = {
    ADD_PREDEFINED_TASK: "AddPredefinedTask",
    EDIT_TASK: "EditTask",
    CREATE_TASK: "CreateTask",
    LIST_OF_TASKS: "listOfTasks",
    TASK_ANALYTICS:"TaskAnalytics",
    EXHIBITOR_TASKS: "ExhibitorTasks",
};
export const cleanPayload = (payload) => {
    return Object.keys(payload).reduce((acc, key) => {
      const value = payload[key];
  
      if (key === "exhibitors" || key === "task_analytics") return acc;
  
      if (value != null && !(Array.isArray(value) && value.length === 0)) {
        acc[key] = value;
      }
  
      return acc;
    }, {});
  };
  

export const validationSchema = Yup.object({
    title: Yup.string()
    .required('Task Title is required')
    .min(3, 'Task Title must be at least 3 characters long')
    .max(100, 'Task Title cannot exceed 100 characters')
    .matches(/^(?! )[A-Za-z0-9\-:()\[\]|,#/<>.&@+! ]+$/, 'Task Title cannot start with a space and may only contain letters, numbers, spaces, and special characters (-:()[]|,#/<>.&@+!).'),
    task_type: Yup.string()
        .required('Task Type is required'),
    description: Yup.string()
        .max(2000, 'Please enter less than 2000 characters')
        .nullable(),
});
export const LABELS = {
    CREATE_TASK: "Create Task",
    EDIT_TASK: "Edit Task"
};
export const TIME_FORMATS = {
    FORMAT_TYPE_1: "h:mm A, DD MMM YY",
    FORMAT_TYPE_2: "YYYY-MM-DD HH:mm:ss",
    FORMAT_TYPE_3: "MMM DD, YYYY",
};


export const TOGGLEMODE = {
    CATEGORY: "category",
    EXHIBITOR: "exhibitor",
};
export const getOptionLabel = (option) => (
    <div className="d-flex aligns-items-center">
        {option.image && (
            <img
                src={option.image}
                alt={option.label}
                style={{ width: "20px", height: "20px", marginRight: "5px" }}
            />
        )}
        {option.icon && (
            <i className={option.icon} style={{ marginRight: "5px" }}></i>
        )}
        {option.label}
    </div>
);
export const ENTITY_MODULES = {
    EXHIBITOR: 'exhibitor',
};
export const handleError = (err) => {
    const errMessage = err?.response?.data?.error || "Something went wrong";
    errorToaster(errMessage);
};
export const mapEntities = (categorized, uncategorized) => {
    const categorizedEntities = categorized.flatMap(category =>
        category.entity.map(entity => ({
            category_name: entity.entity_name,
            category_id: entity.id,
            category_order: entity.entity_order,
        }))
    );

    const uncategorizedEntities = uncategorized.map(entity => ({
        category_name: entity.entity_name,
        category_id: entity.id,
        category_order: entity.entity_order,
    }));

    return [...categorizedEntities, ...uncategorizedEntities];
};
export const options = [
    { label: "Text", value: 1 },
    { label: "File", value: 3 },
    { label: "Information", value: 2 },
];
export const hardcodedTimeZone = "Asia/Kolkata";

export const formatDateWithTimeZone = (e, hardcodedTimeZone) => {
    return moment(e)
        // .tz(hardcodedTimeZone)
        .format("YYYY-MM-DD HH:mm:ss")
        .replace(/ /g, "T");
};
export const FIELD_NAMES = {
    REMINDER_DATE: "reminder_date",
    DUE_DATE: "due_date"
};


export const priorityOptions = [
    {
        label: "High",
        value: 1,
        image:
            "https://d2nnrpx7gk2my2.cloudfront.net/files/67aad4047ac484000871fe7f/iconamoon_arrow-up-2.svg",
    },
    {
        label: "Medium",
        value: 2,
        image:
            "https://d2nnrpx7gk2my2.cloudfront.net/files/67aad43f7ac484000871fe85/iconamoon_arrow-up-2(5).svg",
    },
    {
        label: "Low",
        value: 3,
        image:
            "https://d2nnrpx7gk2my2.cloudfront.net/files/67aad40a7ac484000871fe83/iconamoon_arrow-up-2(3).svg",
    },
];
export const moduleData = [
    {
        module_id: 1,
        module_name: "Exhibitor Logo",
        task_type: 3,
        task_column_mapping: "image_url",
    },
    {
        module_id: 2,
        module_name: "Exhibitor Website URL",
        task_type: 1,
        task_column_mapping: "website_url",
    },
    {
        module_id: 3,
        module_name: "Description",
        task_type: 1,
        task_column_mapping: "description",
    },
    {
        module_id: 4,
        module_name: "Exhibitor Location",
        task_type: 1,
        task_column_mapping: "location",
    },
];
export const categoryEntity = {
    SPONSOR: 1,
    SPEAKER: 2,
    TICKET: 3,
    GALLERY: 4,
    PARTNER: 5,
    EXHIBITOR: 6
}
export const style = {
    color: "#002e6e",
    textDecoration: "none" ,
    cursor:"pointer"
};


export const convertToDateObj = (dateString) => {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
        return null;
    }
    return date;
};
export const theme = {
    rainbow: {
        palette: {
            brand: "#002E6E",
        },
    },
};

export const getEventDateNTime = (date, eventTimeZone = "Asia/Kolkata") => {
    if (!date) return "N/A";

    const m = moment.utc(date).tz(eventTimeZone);
    const timeString = m.format(TIME_FORMATS.FORMAT_TYPE_1);

    const offset = m.format("Z");
    const abbr = m.zoneAbbr();

    const timeZoneDisplay = abbr?.includes('+') || abbr?.includes('-') || abbr === 'UTC'
        ? `GMT${offset}`
        : abbr;

    return `${timeString} ${timeZoneDisplay}`;
};

export const getISTDateNTimeWTimeZone = (date) => {
    if (!date) return "N/A";
    return moment.utc(date) 
        .tz("Asia/Kolkata") 
        .format(TIME_FORMATS.FORMAT_TYPE_1) + " IST";
};
export const EXHIBITOR_TASK_STATUS = {
    PENDING: 1,
    SUBMITTED: 2,
    ACCEPTED: 3,
    APPROVED: 4,
    REJECTED: 5,
    RESUBMIT: 6,
    "RE-SUBMIT": 6
};

export const EXHIBITOR_TASK_TYPES =
 {  "TEXT" : 1,  "INFORMATION" :2 , "FILE" : 3  }

export const getStatusClassName = (status) => {  
    const statusClasses = {
      1: "status-pending",
      2: "status-submitted",
      3: "status-accepted",
      4: "status-approved",
      5: "status-rejected",
      6: "status-resubmit",
    };
  
    return `task-status-common ${statusClasses[status] || ""}`;
  };
  


export const analyticsResponse = {
    body: {
        analytics: {
            "1": 1,
            "2": 1,
            "3": 0,
            "4": 0,
            "5": 0,
            "6": 0
        },
        exhibitors: [
            {
                exhibitor_id: 15942,
                updated_at: "2025-01-15T10:30:00Z",  
                task_status: 1, 
                assignment_id: "19aba90f-b436-4490-9ba9-a5fc6dfe1635",
                response_files: [],
                task_response: null,
                entity_name: "Exhibitor 1"
            },
            {
                exhibitor_id: 15943,
                updated_at: "2025-01-18T12:00:00Z",  
                task_status: 2,  
                assignment_id: "7fc9e72c-df4f-4c50-8f3d-537cf95e9e1e",
                response_files: ["file1.pdf", "file2.jpg"],
                task_response: "Approved",
                entity_name: "Exhibitor 2"
            },
            {
                exhibitor_id: 15944,
                updated_at: null,  
                task_status: 3,
                assignment_id: "d4c9b5b4-b59e-4c1c-b7a5-5b90b3ac1df2",
                response_files: [],
                task_response: null,
                entity_name: "Exhibitor 3"
            }
        ],
        count: 3  
    }
};

export const priorityBasedIcons = {
    HIGH: "https://d2nnrpx7gk2my2.cloudfront.net/files/67aad4047ac484000871fe7f/iconamoon_arrow-up-2.svg",
    MEDIUM: "https://d2nnrpx7gk2my2.cloudfront.net/files/67aad43f7ac484000871fe85/iconamoon_arrow-up-2(5).svg",
    LOW: "https://d2nnrpx7gk2my2.cloudfront.net/files/67aad40a7ac484000871fe83/iconamoon_arrow-up-2(3).svg",
    REDIRECT: redirectIcon,
}

export const getRouteForLinkType = (linkType, eventId) => {
    if (linkType === "eventInfo") {
        return `/e/${eventId}/eventInfo/exhibitor/details`;
    } else if (linkType === "attendeeApp") {
        return `/e/${eventId}/attendee-app/settings/branding`;
    }else if(linkType === "exhibitorsPortal") {
        return `/e/${eventId}/exhibitor-portal/exhibitors`;
    }
    return "/";
};

export const getStatusClass = (status) => {
    switch (status) {
        case "Pending":
            return "pendingStatus task-status-common";
        case "Submitted":
            return "submittedStatus task-status-common";
        case "Approved":
            return "approvedStatus task-status-common";
        case "Rejected":
            return "rejectedStatus task-status-common";
        case "Re-submit":
            return "resubmitStatus task-status-common";
        default:
            return "defaultStatus task-status-common";
    }
};

export const filterTiles = [
    { id: 1, name: "Pending", status: "Pending" },
    { id: 2, name: "Submitted", status: "Submitted" },
    { id: 4, name: "Approved", status: "Approved" },
    { id: 5, name: "Rejected", status: "Rejected" },
    { id: 6, name: "Re-submit", status: "Re-submit" },
    { id: 3, name: "Accepted", status: "Accepted" },
];

export const getTaskStatusText = (status) => {
    switch (status) {
        case EXHIBITOR_TASK_STATUS.PENDING:
            return "Pending";
        case EXHIBITOR_TASK_STATUS.SUBMITTED:
            return "Submitted";
        case EXHIBITOR_TASK_STATUS.ACCEPTED:
            return "Accepted";
        case EXHIBITOR_TASK_STATUS.APPROVED:
            return "Approved";
        case EXHIBITOR_TASK_STATUS.REJECTED:
            return "Rejected";
        case EXHIBITOR_TASK_STATUS.RESUBMIT:
            return "Re-submit";
        default:
            return "Unknown";
    }
};

export const filterTaskByStatus  = {
    PENDING: 1,
    SUBMITTED: 2,
    ACCEPTED: 3,
    APPROVED: 4,
    REJECTED: 5,
    "RE-SUBMIT": 6
};

export const convertToUTC = (date) =>
    date ? moment(date).utc().format("YYYY-MM-DD HH:mm:ss") : null;

export const convertToEventTimeZone = (date,eventDetails) =>
	date ? moment.utc(date).tz(eventDetails?.time_zone).format("YYYY-MM-DD HH:mm:ss") : null;

export const  truncateWord = (word, maxLength = 20) =>{
    if (word.length > maxLength) {
      return word.substring(0, maxLength) + '... ';
    }
    return word;
  }
export const isFilterEmpty = (obj) => {
  return (
    Object.values(obj).every(
      (val) => Array.isArray(val) ? val.length === 0 : !val
    )
  );
};

export const CATEGORY_TYPES = {
    SPONSOR: 1,
    SPEAKER: 2,
    TICKET: 3,
    GALLERY: 4,
    PARTNER: 5,
    EXHIBITOR: 6,
    TASK: 7
};

// helper function related to ability to assign deadline to exhibitors/categories

export const hasChanges = (changes) => {
    return changes?.create_data?.length > 0 ||
        changes?.update_data?.length > 0 ||
        changes?.delete_data?.length > 0;
};
export const datesEqual = (date1, date2) => {
    if (!date1 && !date2) return true;
    if (!date1 || !date2) return false;
    return moment(date1).format('YYYY-MM-DD HH:mm:ss') ===
        moment(date2).format('YYYY-MM-DD HH:mm:ss');
};

// Helper function to create individual deadlines payload
export const createIndividualDeadlinesPayload = (deadlines, selectedItems, type, formik, props) => {
    const deadlinesPayload = {};

    selectedItems?.forEach(item => {
        const itemId = type === "exhibitor" ? item?.category_id : item?.category_id;
        const itemDeadlines = deadlines[itemId];

        deadlinesPayload[itemId] = {
            id: itemId,
            due_date: itemDeadlines?.due_date ?
                getUTCDateNTime(itemDeadlines?.due_date, props?.eventInfo?.time_zone) :
                (formik?.values?.due_date ? getUTCDateNTime(formik?.values.due_date, props?.eventInfo?.time_zone) : null),
            reminder_date: itemDeadlines?.reminder_date ?
                getUTCDateNTime(itemDeadlines?.reminder_date, props?.eventInfo?.time_zone) :
                (formik?.values?.reminder_date ? getUTCDateNTime(formik?.values?.reminder_date, props?.eventInfo?.time_zone) : null)
        };
    });

    return deadlinesPayload;
};

export const categorizeItemChanges = (currentItems, originalItems, timezone) => {
    const create_data = [];
    const update_data = [];
    const delete_data = [];

    // Get IDs for comparison
    const currentIds = currentItems?.map(item => item?.id?.toString());
    const originalIds = originalItems?.map(item => item?.id?.toString()) || [];

    // Find deleted items
    delete_data.push(...originalIds.filter(id => !currentIds?.includes(id)));

    // Process current items
    currentItems?.forEach(item => {
        const itemPayload = {
            id: item?.id?.toString(),
            due_date: item?.due_date ? getUTCDateNTime(item?.due_date, timezone) : null,
            reminder_date: item?.reminder_date ? getUTCDateNTime(item?.reminder_date, timezone) : null
        };

        const originalItem = originalItems?.find(orig => orig.id.toString() === item.id.toString());

        if (originalItem) {
            // Check if dates changed
            const dueChanged = !datesEqual(originalItem?.due_date, item?.due_date);
            const reminderChanged = !datesEqual(originalItem?.reminder_date, item?.reminder_date);

            if (dueChanged || reminderChanged) {
                update_data.push(itemPayload);
            }
        } else {
            // New item
            create_data.push(itemPayload);
        }
    });

    return { create_data, update_data, delete_data };
};

export const buildTaskPayload = (values, isEditMode, timezone) => {
    const payload = {
        task_type: values?.task_type,
        priority: values?.priority,
        title: values?.title,
        description: values?.description,
        task_column_mapping: values?.task_column_mapping || "custom_task",
        task_category_id: parseInt(values?.task_category_id) ,
        auto_assign_type: values?.auto_assign_type
    };

    // Add default dates
    if (values.default_due_date) {
        payload.default_due_date = getUTCDateNTime(values?.default_due_date, timezone);
    }
    if (values.default_reminder_date) {
        payload.default_reminder_date = getUTCDateNTime(values?.default_reminder_date, timezone);
    }

    // Handle files
    if (values?.files?.length > 0) {
        payload.files = values?.files?.map(f => ({ url: f.url || f }));
    }

    if (isEditMode) {        
        const exhibitorChanges = categorizeItemChanges(
            values?.exhibitors?.items || [],
            values?.exhibitors?._original || [],
            timezone
        );

        // include exhibitor changes if they exist
        if (hasChanges(exhibitorChanges)) {
            payload.exhibitors = exhibitorChanges;
        }

        const categoryChanges = categorizeItemChanges(
            values?.categories?.items || [],
            values?.categories?._original || [],
            timezone
        );


        //  if we switched FROM categories (had category_ids but now empty)
        const hadCategoryIds = values?.categories?._original?.length > 0 || 
                               values?.category_ids?.length > 0;
        const hasCurrentCategories = values?.categories?.items?.length > 0;
        
        if (hadCategoryIds && !hasCurrentCategories) {            
            const idsToDelete = [];
            
            // Get IDs from _original
            if (values?.categories?._original?.length > 0) {
                idsToDelete.push(...values.categories._original.map(item => item.id.toString()));
            }
            
            // Also check category_ids (in case _original isn't populated)
            if (values?.category_ids?.length > 0) {
                const categoryIdStrings = values?.category_ids?.map(id => id.toString());
                categoryIdStrings.forEach(id => {
                    if (!idsToDelete.includes(id)) {
                        idsToDelete.push(id);
                    }
                });
            }
            
            if (idsToDelete?.length > 0) {
                payload.categories = {
                    create_data: [],
                    update_data: [],
                    delete_data: idsToDelete
                };
            }
        } else if (hasChanges(categoryChanges)) {
            payload.categories = categoryChanges;
        }
        
    } else {
        // Handle exhibitors
        if (values?.exhibitors?.items?.length > 0) {
            const exhibitorData = values?.exhibitors?.items?.map(item => {
                const due_date = item?.due_date  || null;
                const reminder_date = item?.reminder_date || null;

                return {
                    id: item?.id?.toString(),
                    due_date: due_date ? getUTCDateNTime(due_date, timezone) : null,
                    reminder_date: reminder_date ? getUTCDateNTime(reminder_date, timezone) : null
                };
            })

            if (exhibitorData?.length > 0) {
                payload.exhibitors = {
                    create_data: exhibitorData,
                    update_data: [],
                    delete_data: []
                };   
            }
        }

        if (values?.categories?.items?.length > 0) {
            const categoryData = values?.categories?.items?.map(item => ({
                id: item?.id?.toString(),
                due_date: item?.due_date ? getUTCDateNTime(item?.due_date, timezone) : null,
                reminder_date: item?.reminder_date ? getUTCDateNTime(item?.reminder_date, timezone) : null
            }));

            payload.categories = {
                create_data: categoryData,
                update_data: [],
                delete_data: []
            };
        }

    }

    return payload;
};



export const addExhibitors = (formik, exhibitorsToAdd) => {
    const newItems = exhibitorsToAdd?.map(exhibitor => ({
        id: exhibitor?.category_id || exhibitor?.id,
        entity_name: exhibitor?.entity_name || exhibitor?.category_name,
        // Preserve existing dates if item was already selected, otherwise use defaults
        due_date: exhibitor?.due_date || formik?.values?.default_due_date || null,
        reminder_date: exhibitor?.reminder_date || formik?.values?.default_reminder_date || null
    }));

    formik.setFieldValue('exhibitors.items', newItems);
};

export const addCategories = (formik, categoriesToAdd) => {

    const newItems = categoriesToAdd?.map(category => ({
        id: category?.category_id || category?.id,
        category_name: category?.category_name,
        due_date: category?.due_date || formik?.values?.default_due_date || null,
        reminder_date: category?.reminder_date || formik?.values?.default_reminder_date || null
    }));

    formik.setFieldValue('categories.items', newItems);
};

// Remove exhibitor/category
export const removeExhibitor = (formik, id) => {
    const filtered = formik?.values?.exhibitors?.items?.filter(item => item?.id !== id);
    formik.setFieldValue('exhibitors.items', filtered);
};

export const removeCategory = (formik, id) => {
    const filtered = formik?.values?.categories?.items?.filter(item => item.id !== id);
    formik.setFieldValue('categories.items', filtered);
};

// Helper: Update individual deadlines 
export const updateExhibitorDeadline = (formik, id, field, value) => {
    const items = formik?.values?.exhibitors?.items;
    const updatedItems = items?.map(item =>
        item?.id === id ? { ...item, [field]: value } : item
    );
    formik.setFieldValue('exhibitors.items', updatedItems);
};

export const updateCategoryDeadline = (formik, id, field, value) => {
    const items = formik?.values?.categories?.items;
    const updatedItems = items?.map(item =>
        item?.id === id ? { ...item, [field]: value } : item
    );
    formik.setFieldValue('categories.items', updatedItems);
};

export const updateExhibitorDeadlines = (formik, id, updates) => {
    const items = formik?.values?.exhibitors?.items || [];
    const updatedItems = items?.map(item =>
        item?.id === id ? { ...item, ...updates } : item
    );

    formik.setFieldValue('exhibitors.items', updatedItems);
};

export const updateCategoryDeadlines = (formik, id, updates) => {
    const items = formik?.values?.categories?.items || [];
    const updatedItems = items?.map(item =>
        item?.id === id ? { ...item, ...updates } : item
    );

    formik.setFieldValue('categories.items', updatedItems);
};

// Update all deadlines when default changes 
export const syncAllWithDefaults = (formik, type, dateType, newValue) => {
    if (type === 'exhibitor') {
        const items = formik?.values?.exhibitors?.items;
        const updated = items?.map(item => ({
            ...item,
            [dateType]: newValue
        }));
        formik.setFieldValue('exhibitors.items', updated);
    } else {
        const items = formik?.values?.categories?.items;
        const updated = items?.map(item => ({
            ...item,
            [dateType]: newValue
        }));
        formik.setFieldValue('categories.items', updated);
    }
};

export const rainbowtheme = {
    rainbow: {
      palette: {
        brand: "#002E6E"
      }
    }
  };

export const mapToItemField = (dateType) => {
  if (dateType === 'default_due_date') return 'due_date';
  if (dateType === 'default_reminder_date') return 'reminder_date';
  return dateType;
};